import _ from 'underscore';

export default class OrderNotifications {
  constructor($scope, OrderService) {
    function load_data() {
      OrderService.get_notifications(window.order.id).success(function(data) {
        if (data.success) {
          $scope.notifications = data.notifications;
          _.each($scope.notifications, function(notification) {
            _.each(notification.attachments, function(attachment) {
              attachment.doc_type_str = _.findWhere($scope.doc_types, {
                id: attachment.doc_type
              }).title;
            });
          });
        }
      });
    }

    $scope.resend_notification = function(notification) {
      if (confirm('Are you sure you want to resend this notification?')) {
        notification.resending = true;
        OrderService.resend_notification(notification.id).success(function(data) {
          if (data.success) {
            notification.resending = false;
            load_data();
          }
        });
      }
    };

    $scope.init = function() {
      $scope.doc_types = window.document_types;
      load_data();
    };

    $scope.init();
  }
}

OrderNotifications.$inject = ['$scope', 'OrderService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/order-notifications.ctrl.js